import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DarkModeProvider } from './contexts/DarkModeProvider';
import Layout from './components/Layout';
import Home from './pages/Home';
import Playlist from './pages/Playlist';
import AuthCallback from './pages/AuthCallback';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './App.css';

export default function App() {
  return (
    <DarkModeProvider>
      <Router>
        <Layout>
          <Routes>
            <Route index element={<Home />} />
            <Route path="playlist/:id" element={<Playlist />} />
            <Route path="auth/callback" element={<AuthCallback />} />
            <Route path="about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </Layout>
      </Router>
    </DarkModeProvider>
  );
}
